import React from "react";
import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ConsultationDialog from "./components/ConsultationDialog";
import { ConsultationProvider } from "./components/ConsultationContext";

import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Insights from "./pages/Insights";
import InsightDetail from "./pages/InsightDetail";
import Resources from "./pages/Resources";
import Media from "./pages/Media";
import Contact from "./pages/Contact";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
}

function Shell() {
  const [open, setOpen] = React.useState(false);
  const [defaultService, setDefaultService] = React.useState("");

  const openConsult = (service = "") => {
    setDefaultService(service || "");
    setOpen(true);
  };

  return (
    <ConsultationProvider onOpen={openConsult}>
      <div className="fixed top-0 left-0 right-0 z-50">
        <Navbar onConsult={() => openConsult()} />
      </div>
      <main className="min-h-[60vh]">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/insights" element={<Insights />} />
          <Route path="/insights/:slug" element={<InsightDetail />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/media" element={<Media />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      <Footer />
      <ConsultationDialog open={open} onClose={() => setOpen(false)} defaultService={defaultService} />
    </ConsultationProvider>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Shell />
      </BrowserRouter>
    </div>
  );
}

export default App;
